/* global API, Site */

import { createApp } from 'vue';
import Paginate from 'vuejs-paginate-next';

import { useQuery, useLoading } from './composables/data';
import { usePaginationData, usePages, useChangePage, usePageStart, usePageEnd } from './composables/paging';
import { useOpenEmbed, useCloseEmbed, useEmbedData, useCreateEmbed, useCopyEmbed } from './composables/embed';

// Vue element
const vueSelector = '.vue-moks';
const vueElement = document.querySelector(vueSelector);

if (vueElement) {
	let postTypes = '';

	if (vueElement.dataset.vuePosttype) {
		postTypes = vueElement.dataset.vuePosttype.split(' ');
	}

	createApp({
		components: {
			Paginate,
		},
		data() {
			return {
				lang: Site.lang_slug,
				results: {},
				postTypes,
				useQuery,
				usePaginationData,
				fetchesLoading: {},
				useEmbedData,
			};
		},
		computed: {
			useLoading,
		},
		mounted() {
			if (vueElement.dataset.vuePostsperpage) {
				this.usePaginationData.postsPerPage = parseInt(vueElement.dataset.vuePostsperpage, 10);
			}

			this.search();
		},
		methods: {
			/**
			 * Hakufunktio
			 * @param {boolean} log Logataanko haku
			 */
			search(log = false) {
				this.useQuery.log = log;
				this.postTypes.forEach((index) => {
					// fetchit ajetaan suunnilleen samaan aikaan, laitetaan objektiin jokaisen fetchin lataustila
					this.fetchesLoading[index] = true;

					this.usePaginationData.page = 1;

					fetch(`${API.url}/search`, {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json; charset=utf-8',
							'X-WP-Nonce': API.nonce,
						},
						// body: JSON.stringify(this.query),
						body: JSON.stringify({
							post_type: index,
						}),
					})
						.then((res) => res.json())
						.then((response) => {
							this.results[index] = response;
						})
						.catch((err) => {
							console.error(err);
						})
						.finally(() => {
							// fetch on valmis
							this.fetchesLoading[index] = false;
						});
				});
			},
			usePageStart,
			usePageEnd,
			useChangePage,
			usePages,
			useOpenEmbed,
			useCloseEmbed,
			useCreateEmbed,
			useCopyEmbed,
		},
	}).mount(vueSelector);
}
